export function stripCnpjMask (value) {
  if (!value) return value
  return value.replace(/[.\-/\s]/g, '')
}
